// The first run's wizard (STAGE_7 7.9): its state on the server, and the steps in order.

import type { Schemas } from '@/api/client';

export type Setup = Schemas['SetupOut'];
export type SetupStep = Schemas['SetupStep'];

export const SETUP_KEY = 'setup';

export const STEPS: readonly SetupStep[] = [
  'org',
  'logo',
  'money',
  'map',
  'prices',
  'staff',
  'vehicles',
  'operator',
];

// Whom the wizard was already offered to since the page loaded: once per sign-in is an
// offer, every click back to the journal would be a trap.
const offered = new Set<number>();

export function wasOffered(userId: number): boolean {
  return offered.has(userId);
}

export function markOffered(userId: number): void {
  offered.add(userId);
}

/** For tests: the page loaded afresh. */
export function forgetOffers(): void {
  offered.clear();
}
